import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BsCalendar4Week, BsFileEarmarkCheck } from "react-icons/bs";
import { FaThumbsUp, FaUser, FaRegThumbsUp } from "react-icons/fa";
import { useSelector } from "react-redux";
import { HiOutlineUserGroup } from "react-icons/hi";
import { BsBriefcase } from "react-icons/bs";
import api from "../../services/api";

import { classNames } from "../../utils";

export default function UserCard({ user}) {
  const navigate = useNavigate();

  const u = useSelector((state) => state.Auth.user);

  const [values, setValues] = useState(user);
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const handleLike = async (keyword) => {
    const newKeyWords = values.key_words.map((kw) => {
      if (kw._id === keyword._id) {
        if (kw.likes.includes(u._id)) {
          const newLikes = kw.likes.filter((like) => like !== u._id);
          return { ...kw, likes: newLikes };
        } else {
          const newLikes = [...kw.likes, u._id];
          return { ...kw, likes: newLikes };
        }
      } else {
        return kw;
      }
    });
    const { data } = await api.put(`/user/${user._id}`, { ...values, key_words: newKeyWords });
    setValues(data);
  };

  return (
    <div className={classNames("relative bg-white rounded-lg border flex flex-col shadow-sm hover:shadow-md transition-shadow", user.status === "active" ? "opacity-100" : "opacity-50")}>
      {/* Header avec image et nom/rôles */}
      <div className="flex items-start gap-4 p-4">
        <div className="relative shrink-0">
          <img
            src={user.avatar || "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"}
            alt="userlogo"
            className="rounded-full w-14 h-14 object-cover border-2 border-gray-100"
          />
        </div>
        
        <div className="flex-1 flex flex-col">
          <div className="flex items-center justify-between gap-1">
            <h3
              className="font-semibold flex m-0 cursor-pointer hover:text-blue-600 transition-colors"
              onClick={() => {
                query.set("user_modal_id", user._id);
                navigate({ search: query.toString() });
              }}>
              {user.name}
            </h3>

            {user.calendly && (
            <a href={user.calendly} onClick={(e) => e.stopPropagation()} target="_blank" className="relative mt-2" rel="noreferrer">
              <BsCalendar4Week className="w-5 h-5 text-blue-500 hover:text-blue-600" />
            </a>
          )}
            {user.status === "inactive" ? <span className="bg-red-100 text-red-700 border-red-200 border-[1px] uppercase text-[10px] px-2 py-0.5 rounded-full">inactive</span> : null}
          </div>
          
          <div className="text-xs font-normal text-gray-600 mt-1">{user.job_title}</div>
          
          {/* Role tags */}
          <div className="flex flex-wrap gap-1.5 mt-2">
            {user.role && (
              <div className="flex items-center gap-1 bg-purple-50 text-purple-700 px-1.5 py-0.5 rounded-full text-[10px] border border-purple-200">
                <FaUser className="w-2.5 h-2.5" />
                <span className="capitalize">{user.role}</span>
              </div>
            )}
            
            {user.organisation_name && (
              <div className="flex items-center gap-1 bg-green-50 text-green-700 px-1.5 py-0.5 rounded-full text-[10px] border border-green-200">
                <HiOutlineUserGroup className="w-2.5 h-2.5" />
                <span>{user.organisation_name}</span>
              </div>
            )}
            
            {user.contract && (
              <div className="flex items-center gap-1 bg-amber-50 text-amber-700 px-1.5 py-0.5 rounded-full text-[10px] border border-amber-200">
                <BsBriefcase className="w-2.5 h-2.5" />
                <span>{user.contract}</span>
              </div>
            )}
          </div>
          

        </div>
      </div>
      
      {/* Contenu en pleine largeur */}
      <div className="flex-1 flex flex-col px-4">
        <div className="w-full flex gap-1 overflow-x-auto py-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
          {values?.key_words
            ?.sort((a, b) => b.likes.length - a.likes.length)
            ?.map((keyword) => (
              <div key={keyword.name} className="flex flex-row gap-1 items-center rounded-lg bg-blue-50 text-blue-800 px-2 border-[1px] border-blue-200 text-[10px] text-nowrap">
                {keyword.name}
                <button className="flex flex-row gap-1 text-blue-600 hover:text-blue-800 " onClick={() => handleLike(keyword)}>
                  <FaThumbsUp className={`${keyword.likes.includes(u._id) ? "text-blue-600" : "text-gray-400"}`} />
                  <p>{keyword.likes.length > 0 ? keyword.likes.length : " "}</p>
                </button>
              </div>
            ))}
        </div>

        <Description value={user.description} />
        {user.last_login_at && (
          <div className="text-xs text-gray-500 mt-1">
            Last login: {new Date(user.last_login_at).toLocaleDateString()} {new Date(user.last_login_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
          </div>
        )}

        <div className="mt-auto p-2 flex justify-end gap-2">
          <button
            className="text-xs text-blue-500 border-blue-500 border-[1px] rounded-lg py-1.5 px-3 hover:bg-blue-500 hover:text-white transition-colors"
            onClick={() => {
              query.set("user_modal_id", user._id);
              navigate({ search: query.toString() });
            }}>
            View profile
          </button>
        </div>
      </div>
    </div>
  );
}

const Description = ({ value }) => {
  const LIMIT = 100;

  return (
    <div className="px-2">
      <p className="text-sm text-gray-500">
        {value?.substring(0, LIMIT)}
        {value?.length > LIMIT && "..."}
      </p>
    </div>
  );
};
